import React, { createContext, useContext } from "react";

/**
 * DemoMode context — when `true`, any component down the tree can decide
 * to short-circuit real backend writes and pretend the action succeeded.
 *
 * Used exclusively by `/demo` (public prospect preview of NDS-1) so a
 * visitor can click every card, open every popup, fill every form — and
 * nothing hits the real CRM / SMS / Friction Audit endpoints.
 *
 * Read side never has to touch this. The 5 nex-os read endpoints
 * (schema, kpis, live-feed, capability-metrics, step-records) are public
 * and safe to query as-is.
 */
const DemoModeContext = createContext(false);

export function DemoModeProvider({ value, children }) {
  return (
    <DemoModeContext.Provider value={!!value}>
      {children}
    </DemoModeContext.Provider>
  );
}

export function useDemoMode() {
  return useContext(DemoModeContext);
}
